/** Builds Auth0 appState return path payload from pathname/search. */
function buildAuth0ReturnTo(pathname: string, search: string): string {
  return `${pathname}${search}`;
}

/** Builds Auth0 appState object used during loginWithRedirect. */
export function buildAuth0AppState(pathname: string, search: string): { returnTo: string } {
  return { returnTo: buildAuth0ReturnTo(pathname, search) };
}

type RestoreAuth0CallbackPathParams = {
  appState?: { returnTo?: string };
  pathname: string;
  replaceState: (url: string) => void;
};

/** Restores callback path after Auth0 redirect. */
export function restoreAuth0CallbackPath({ appState, pathname, replaceState }: RestoreAuth0CallbackPathParams): void {
  const returnTo = appState?.returnTo;

  if (returnTo && returnTo.startsWith("/")) {
    replaceState(returnTo);
    return;
  }

  replaceState(pathname);
}

/**
 * Auth0 onRedirectCallback that restores the pre-login path/query using
 * window.history.replaceState. Pass directly to SharedAuth0Provider.
 */
export function onAuth0Redirect(appState?: { returnTo?: string }): void {
  restoreAuth0CallbackPath({
    appState,
    pathname: window.location.pathname,
    replaceState: url => {
      window.history.replaceState({}, document.title, url);
      window.dispatchEvent(new PopStateEvent("popstate", { state: window.history.state }));
    },
  });
}
